import { html } from 'lit';
import { api } from '@converse/headless';
import { __ } from 'i18n';
import BaseModal from 'plugins/modal/modal.js';
import { modal_close_button } from 'plugins/modal/templates/buttons.js';

export default class SonataLogoutModal extends BaseModal {
    getModalTitle() {
        return __('Бажаєте покинути застосунок?');
    }

    getModalDialogClasses() {
        return 'modal-dialog-centered';
    }

    renderModal() {
        return html`<button type="button" class="btn btn-danger" @click="${this.confirmLogout}">${__('Вийти')}</button> ${modal_close_button}`;
    }

    renderModalFooter() {
        return html``;
    }

    confirmLogout() {
        this.close();
        api.user.logout();
    }
}

api.elements.define('sonata-logout-modal', SonataLogoutModal);
